import { themeColor, themeFontFamily } from 'LibNeo/theme'
import styled, { css } from 'styled-components'
import { Switch as SwitchAnt } from 'antd'
import { IconComponent } from 'LibNeo'

export const SwitchAntStyle = styled(SwitchAnt)`
	min-width: auto;
	width: 40px;
	height: 20px;
	margin: 0;
	border: none;
	border-radius: 20px;
	font-family: ${themeFontFamily('SBSansInterface')};
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	background-color: ${themeColor('gray', 4)};
	color: ${themeColor('extraBackground3')};
	overflow: hidden;
	&:after {
		background-color: ${themeColor('white')};
		width: 16px;
		height: 16px;
		top: 2px;
		left: 2px;
		box-shadow: none;
	}
	&.ant-switch-disabled {
		opacity: 1;
		background-color: ${themeColor('gray', 1)};
		&:after {
			background-color: ${themeColor('gray', 3)};
		}
		&:hover,
		&:focus {
			background-color: ${themeColor('gray', 1)};
		}
	}
	.ant-click-animating-node {
		display: none;
	}
	&:focus,
	&:hover {
		box-shadow: none;
		background-color: ${themeColor('gray', 5)};
	}
	&.ant-switch-checked {
		background-color: ${themeColor('emerald', 5)};
		&:focus,
		&:hover {
			background-color: ${themeColor('emerald', 6)};
		}
		&:after {
			background-color: ${themeColor('white')};
			margin-left: -2px;
			left: 100%;
		}
		&.ant-switch-disabled {
			background-color: ${themeColor('emerald', 3)};
			&:after {
				background-color: ${themeColor('emerald', 1)};
			}
			&:hover,
			&:focus {
				background-color: ${themeColor('emerald', 3)};
			}
		}
	}
`
export const SwitchTitle = styled.div<{
	disabled?: boolean
}>`
	margin-left: 12px;
	font-size: 12px;
	line-height: 20px;
	font-family: ${themeFontFamily('SBSansInterface')};
	color: ${themeColor('gray', 8)};
	overflow-wrap: anywhere;

	${({ disabled }) =>
		disabled &&
		css`
			color: ${themeColor('gray', 5)};
			user-select: none;
			cursor: not-allowed;
		`}
`

export const SwitchContainer = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	.ant-form-item {
		.ant-switch {
			margin: 0;
		}
	}
	.ant-form-item-children {
		display: flex;
		align-items: center;
	}
`
export const SwitchIcon = styled(IconComponent)`
	margin: 0 0 0 4px;
`
